import { useEffect, useState } from 'react';
const useRequestAnimationFrame = () => {
    const [isContainerReady, setIsContainerReady] = useState(false);
    // This `useEffect` handles the situation when whole interface (<MainContentBody/>) is stuck for some seconds on
    // reentering the page.
    useEffect(() => {
        const id = requestAnimationFrame(() => setIsContainerReady(true));
        return () => cancelAnimationFrame(id);
    }, []);
    return { isContainerReady };
};
export { useRequestAnimationFrame };
